import axios from "axios";
import { gapi } from "./api.js";
import str from '../index.js'

const url = gapi + "busMain";


const busesMain = {
  namespaced: true,
  state: {
    busesMAll: [],
    emps:[]
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.busesMAll;
    },
    getTodoById: (state) => (id) => {
      return state.busesMAll.find((todo) => todo.id == id);
    },
  },
  mutations: {
    SET_DATA(state, data) {
      state.busesMAll = data;
    },

    ADD_DATA(state, data) {
      this.emps = str.state.emps.find((todo) => todo.id == data.empFollow);
      data.Fname = this.emps.Fname
      data.Ffname = this.emps.Ffname
      state.busesMAll.unshift(data);
    },
  
    UPDATE_DATA(state, data) { 
      const index = state.busesMAll.findIndex((t) => t.id === data.id);
   

      this.emps = str.state.emps.find((todo) => todo.id == data.empFollow);
      var dts = {
               id : data.id,
               busID : data.busID,
               mainType : data.mainType,
               coseMain : data.coseMain,
               Details : data.Details,
               empFollow : data.empFollow,
               mainStart : data.mainStart,
               mainEnd : data.mainEnd,
               totalCost : data.totalCost,
               Fname : this.emps.Fname,
               Ffname : this.emps.Ffname
              
                     }
      if (index !== -1) {
        state.busesMAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.busesMAll = state.busesMAll.filter((t) => data.id !== t.id);
    },
  },
  actions: {

    async fetchData({ commit }) {
      await axios
        .get(url,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all data view with reletion
  
    // add student
    async addData({ commit }, data) {
      await axios
        .post(url, data,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("ADD_DATA", res.data.data);
        })
        .catch((error) => console.log(error));
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id,{headers:{Authorization: str.state.token}})
        .then((res) => {
          return res.data.data;

        })
        .catch((error) => console.log(error));
    },
    // update student
    async updateData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .put(app, data,{headers:{Authorization: str.state.token}})
        .then(
          commit("UPDATE_DATA", data)

        )
        .catch((error) => console.log(error));
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app,{headers:{Authorization: str.state.token}})
        .then(
          commit("DELETE_DATA", data)
 
        )
        .catch((error) => console.log(error));
    },
  },
};
export default busesMain;
